export const adaptPrecioMasivo = (precioData) => {
    return {
        idPreciosMasivos: precioData?.idPreciosMasivos,
        fechaIngreso: precioData?.fechaIngreso,
        cantidad: precioData?.cantidad,
        estado: precioData?.estado,
        autorizador: precioData?.autorizador,
        solicitante: precioData?.solicitante,
        usuarioEjecutador: precioData?.usuarioEjecutador,
        fechaEjecucion: precioData?.fechaEjecucion,
        observaciones: precioData?.observaciones,
        idUsuarioAutorizador: precioData?.idUsuarioAutorizador,
        idUsuarioSolicitante: precioData?.idUsuarioSolicitante
    }
}

export const adaptPrecioMasivoArray = (
    precios
) => {
    return structuredClone(precios?.listaPreciosMasivos.valorEsperado)
        ?.map(precio => adaptPrecioMasivo(precio));
}